/** 框选绘制事件名称 */
export const DRAW_MOUSE_OPERATE = 'mouse-operate-draw';

/** 清除框选绘制 */
export const CLEAR_MOUSE_OPERATE = 'clear-mouse-operate';
